export const RADIO: ("check" | "transfer" | "cash" | "creditcard")[] = [
  "cash",
  "transfer",
  "check",
  "creditcard",
];
